<ng-container *ngIf="ready == false">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>

<ng-container *ngIf="ready">
  <ng-container *ngIf="depositSaved === false">

    <div class="dlg-hdr">
      <div class="dlg-hdr__title">
        <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance</mat-icon></div>
        <div>
          <span>Constitución del crédito</span>
        </div>
      </div>
      <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="dlg-body">
      <div class="row">
        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="Paided" placeholder="" name="constitucionDelCreditoCreditos.fecha" required
              [(ngModel)]="constitucionDelCreditoCreditos.fecha" />
            <mat-datepicker-toggle matSuffix [for]="Paided"></mat-datepicker-toggle>
            <mat-datepicker #Paided></mat-datepicker>
            <mat-error *ngIf="invalidDate">Campo requerido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-4">
          <app-input inputType="text" placeholder="Concepto" [isRequired]="true"
            [(ngModel)]="constitucionDelCreditoCreditos.concepto"></app-input>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <input type="text" matInput placeholder="Importe" [(ngModel)]="constitucionDelCreditoCreditos.importe"
              value="constitucionDelCreditoCreditos.importe" class="" required numberDecimalsDirective>
            <mat-error *ngIf="invalidImporte">Campo requerido</mat-error>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <input type="text" matInput placeholder="Comisión Apertura"
              [(ngModel)]="constitucionDelCreditoCreditos.comisionApertura"
              value="constitucionDelCreditoCreditos.comisionApertura" class="" numberDecimalsDirective>
          </mat-form-field>
        </div>

        <div class="col-4">
          <mat-form-field class="w-100 mb-2">
            <input type="text" matInput placeholder="Gastos Bancarios"
              [(ngModel)]="constitucionDelCreditoCreditos.gastosBancarios"
              value="constitucionDelCreditoCreditos.gastosBancarios" class="" numberDecimalsDirective>
          </mat-form-field>
        </div>

        <!-- Actividades -->
        <div class="col-4">
          <app-autocomplete-select [items]="activities" [(selectedItemId)]="constitucionDelCreditoCreditos.activitiesUid"
            [idField]="'uid'" [displayField]="'name'" placeholder="Actividad">
          </app-autocomplete-select>
        </div>

        <div class="col-4">
          <app-autocomplete-select [items]="bankAccounts"
            [(selectedItemId)]="constitucionDelCreditoCreditos.bankAccountsUid" [idField]="'uid'"
            [displayFields]="['bank', 'iban']" placeholder="Cuentas bancarias">
          </app-autocomplete-select>
        </div>
        <!-- Proyecto -->
        <div class="col-4" *ngIf="isProjectEnable && projects?.length > 0">
          <app-autocomplete-select [items]="projects" [(selectedItemId)]="constitucionDelCreditoCreditos.projectUid"
            [idField]="'id'" [displayField]="'display'" placeholder="Proyecto">
          </app-autocomplete-select>
        </div>

        <!-- Tipo de gasto del proyecto -->
        <div class="col-4" *ngIf="isProjectEnable && expenseProjectTypes?.length > 0">
          <app-autocomplete-select [items]="expenseProjectTypes"
            [(selectedItemId)]="constitucionDelCreditoCreditos.expenseProjectTypeUid" [idField]="'id'"
            [displayField]="'display'" placeholder="Tipo de proyecto de gasto">
          </app-autocomplete-select>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dlg-actions">
      <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="dlg-btn-save" (click)="pay()">
        <mat-icon>save</mat-icon>
        {{ isEditMode === true ? 'Actualizar' : 'Añadir'}}
      </button>
    </mat-dialog-actions>

  </ng-container>

  <ng-container *ngIf="depositSaved === true">
    <div class="dlg-hdr">
      <div class="dlg-hdr__title">
        <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance</mat-icon></div>
        <div><span>Constitución del crédito</span></div>
      </div>
      <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="dlg-body">
      <div class="delete-info delete-info--success">
        <mat-icon>check_circle</mat-icon>
        <div class="delete-info__text">
          Constitución {{ isEditMode === true ? 'actualizada': 'añadida' }} correctamente
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dlg-actions">
      <button mat-stroked-button (click)="closeDialog()">
        <mat-icon>close</mat-icon> Cerrar
      </button>
    </mat-dialog-actions>
  </ng-container>

  <!-- Listado -->
  <ng-container *ngIf="list == true">
    <mat-dialog-content class="dlg-body">
      <div class="dlg-empty-list">Listado</div>

      <div class="movimiento-tarjeta-credito-listado">
        <app-table [columns]="headerTable" [dataSource]="dataSource" [hasSelect]="false" [hasButton]="true"
          [actionsTemplate]="actionsButtons">
        </app-table>
      </div>

      <ng-template #actionsButtons let-uid="uid">
        <ng-container *ngFor="let row of (dataSource | filter : uid : 'uid'); trackBy: trackByIndex">
          <ul class="custom-class">
            <li (click)="edit(uid)">
              <a>
                <mat-icon>create</mat-icon> Editar
              </a>
            </li>
            <li (click)="delete(uid)">
              <a>
                <mat-icon>warning</mat-icon> Borrar
              </a>
            </li>
          </ul>
        </ng-container>
      </ng-template>
    </mat-dialog-content>
  </ng-container>

</ng-container>
